import React, {useEffect, useRef, useState} from "react";
import CardTotalGain from "../../../components/Report/CardTotalGain";
import CardTotalLoss from "../../../components/Report/CardTotalLoss";
import CardProfitPrejudice from "../../../components/Report/CardProfitPrejudice";
import ReportTrading from "../../../components/Report/ReportTrading";
import DivDiagonal from "../../../components/DivDiagonal";
import {Form} from "@unform/web";
import * as Yup from "yup";
import {toast} from "react-toastify";
import messageTypes from "../../../constants/MessagesTypes";
import {AiOutlineSearch} from "react-icons/ai";
import CustomButton from "../../../components/Form/Button";
import {dateCurrent, dateFirstDayCurrent} from "../../../utils/date";
import DateShortcuts, {useDateShortcuts} from "../../../components/Form/DateShortcuts";
import CardTotalOperations from "../../../components/Report/CardTotalOperations";
import InputDate from "../../../components/Form/InputDate";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {TradingWrapper, ContentArea} from "../../Trading/styles";
import {FormWrapper} from "../../../styles/listPageTheme";
import {
    TradingReportStack,
    TradingPageHeader,
    TradingWideCardColumn,
    PageInner,
    FilterSection,
    FilterTitle,
    FilterRow,
    FilterField,
    FilterActions,
    calcPrimaryButtonStyle,
    MetricsSectionsStack,
    MetricsSection,
    MetricsSectionTitle,
    MetricsGrid,
    ReportTableBlock,
    TradingReportCard,
    TradingReportCardsStack,
} from "./styles";

export default function TradingReport() {
    const formRef = useRef(null);
    const { t } = useTranslation();
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );

    const [filter, setFilter] = useState([
        {
            startDate: dateFirstDayCurrent(),
            endDate: dateCurrent(),
        }
    ]);

    const dateShortcuts = useDateShortcuts((startDate, endDate) => {
        setFilter([{startDate, endDate}]);
    });

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            dateShortcuts.clearShortcut();
            setFilter(
              [{
                  startDate: data.startDate,
                  endDate: data.endDate,
              }]
            );

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = calcPrimaryButtonStyle.boxShadow;
    };

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <PageInner>
                            <TradingReportStack>
                                <TradingPageHeader>
                                    <h1>
                                        <i className="far fa-file-alt" aria-hidden="true"/>
                                        {' '}{t('traging_report_title')}
                                    </h1>
                                </TradingPageHeader>

                                <TradingWideCardColumn>
                                    <TradingReportCardsStack>
                                        <TradingReportCard>
                                            <FilterSection>
                                                <Form ref={formRef} onSubmit={handleSubmit}>
                                                    <FilterTitle>
                                                        <i className="fas fa-funnel-dollar" aria-hidden="true"/>
                                                        {t('filter')}
                                                    </FilterTitle>
                                                    <DateShortcuts {...dateShortcuts}/>
                                                    <FormWrapper>
                                                        <FilterRow>
                                                            <FilterField>
                                                                <InputDate
                                                                    key={`startDate-${dateShortcuts.inputKey}`}
                                                                    name="startDate"
                                                                    label={t('filter_start_date')}
                                                                    value={dateShortcuts.dateRange.startDate}
                                                                    size="small"
                                                                />
                                                            </FilterField>
                                                            <FilterField>
                                                                <InputDate
                                                                    key={`endDate-${dateShortcuts.inputKey}`}
                                                                    name="endDate"
                                                                    label={t('filter_end_date')}
                                                                    value={dateShortcuts.dateRange.endDate}
                                                                    size="small"
                                                                />
                                                            </FilterField>
                                                            <FilterActions>
                                                                <CustomButton
                                                                    type="submit"
                                                                    style={calcPrimaryButtonStyle}
                                                                    onMouseEnter={buttonHoverIn}
                                                                    onMouseLeave={buttonHoverOut}
                                                                    startIcon={<AiOutlineSearch/>}
                                                                >
                                                                    {t('filter_btn_submmit')}
                                                                </CustomButton>
                                                            </FilterActions>
                                                        </FilterRow>
                                                    </FormWrapper>
                                                </Form>
                                            </FilterSection>
                                        </TradingReportCard>

                                        <TradingReportCard>
                                            <MetricsSectionsStack>
                                                <MetricsSection aria-labelledby="report-section-wins">
                                                    <MetricsSectionTitle id="report-section-wins">
                                                        {t('trading_report_section_wins')}
                                                    </MetricsSectionTitle>
                                                    <CardTotalGain filter={filter}/>
                                                </MetricsSection>
                                                <MetricsSection aria-labelledby="report-section-losses">
                                                    <MetricsSectionTitle id="report-section-losses">
                                                        {t('trading_report_section_losses')}
                                                    </MetricsSectionTitle>
                                                    <CardTotalLoss filter={filter}/>
                                                </MetricsSection>
                                                <MetricsSection aria-labelledby="report-section-summary">
                                                    <MetricsSectionTitle id="report-section-summary">
                                                        {t('trading_report_section_summary')}
                                                    </MetricsSectionTitle>
                                                    <MetricsGrid>
                                                        <CardTotalOperations filter={filter}/>
                                                        <CardProfitPrejudice filter={filter}/>
                                                    </MetricsGrid>
                                                </MetricsSection>
                                            </MetricsSectionsStack>

                                            <ReportTableBlock>
                                                <ReportTrading filter={filter}/>
                                            </ReportTableBlock>
                                        </TradingReportCard>
                                    </TradingReportCardsStack>
                                </TradingWideCardColumn>
                            </TradingReportStack>
                        </PageInner>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
